export enum CustomFieldEnum {
  CLIENT = 'CLIENT',
  CONTACT = 'CLIENT_CONTACT',
  CRM_JOB = 'CRM_JOB',
  LEAD = 'LEAD',
}
